<template>
    <div class="col-12 col-lg-8 offset-0 offset-lg-2">
        <div class="account__card account__card--shadow account__card--border-bottom px-4">
            <div class="account__border">
                <div class="account__card--topbar account__card--topbar--padding d-flex align-items-start">
                    <h3 class="text--green font-weight-bold">{{ $t("resetPassword.chooseNewPassword") }}</h3>
                </div>
            </div>
            <div>
                <div class="account__border py-4">
                    <p v-html="$t('resetPassword.description')"></p>
                    <div class="account--padding">
                        <div class="row">
                            <div class="col-12 mb-4">
                                <div>{{ $t("resetPassword.email") }}</div>
                                <span :class="{'input--after': checkInput('email') }">
                                    <input
                                        v-model="email"
                                        name="email"
                                        class="input"
                                        :class="{'input--error': checkInput('email') }"
                                        @change="checkForm()"
                                        @submit="submitForm"
                                        type="email"
                                        :placeholder="$t('resetPassword.email')"
                                    >
                                </span>
                                <section style="display: flex; flex-direction: column;">
                                    <small
                                        v-for="error in emailValidationErrors"
                                        v-text="error.errorMessage"
                                        class="text-danger"
                                    ></small>
                                </section>

                                <p class="input__subtext mt-3">
                                    <i v-html="$t('resetPassword.note')"></i>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="account__card--bottom-bar align-items-center py-3">
                    <a href="/" class="button button--clear m-0">{{ $t("myAccount.cancel") }}</a>
                    <button @click="submitForm" class="button-brekz button-brekz--rounded button-brekz--xl m-0 button-brekz--green">
                        <span>{{ $t("resetPassword.submit") }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import validationRules from '../js/validation/rules';

    export default {
        name: "PasswordReset",
        props: {
            isMobile: Boolean,
            serverSideValidationErrors: {
                type: Array,
                default: [],
                required: false,
            }
        },
        components: {  },
        data() {
            return {
                email: '',
                isLoading: true,
                errorBag: [],
                isSubmitting: false,
                errorText: '',
                showErrorModal: false,
            }
        },
        methods: {
            checkForm() {
                let success = true;
                this.errorBag = [];

                if ( !validationRules.email(this.email)){
                    success = false;

                    this.errorBag.push({
                        "fieldName": "email",
                        "errorMessage" : this.$t('myAccount.errorEmail')
                    });
                }

                return success;
            },
            submitForm(event) {
                event.preventDefault();

                if (! this.checkForm()) {
                    return;
                }

                event.target.closest('form').submit();
            },
            checkInput(inputName) {
                for (let i = 0; i < this.errorBag.length; i++) {
                    if (this.errorBag[i].fieldName === inputName) {
                        return true;
                    }
                }

                return false;
            },
        },
        mounted() {
            this.errorBag = this.serverSideValidationErrors.map((error) => ({
                "fieldName": "email",
                "errorMessage": error
            }));
        },
        computed: {
            emailValidationErrors() {
                return this.errorBag.filter((value) => value.fieldName === 'email');
            }
        }
    }
</script>
